import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
};

const ConsignatarioPageController = () => {
  //estados globais
  const consignatarioState = useAppSelector((state) => state.consignatario);

  const Page = pages[consignatarioState.page];

  return <Page key={consignatarioState.page} />;
};

export default ConsignatarioPageController;
